module.exports = __webpack_public_path__ + "static/img/czy34.6572925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/czy34.jpg
// module id = 9iP9
// module chunks = 73